import { Checkbox, RadioButton, typography } from '@joor/design-system'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 26px;
`

export const Types = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 0;
`

export const StyledRadioButton = styled(RadioButton)`
  width: 100%;
  padding: 16px 20px;
  background-color: var(--color-neutral-000);
  border: 1px solid var(--color-primary-200);
  border-radius: var(--size-border-radius-small);
  ${typography.alpha.primaryActive.body2};

  &.checked {
    background-color: var(--color-secondary-200);
    color: var(--color-secondary-800);
    border-color: var(--color-secondary-800);
  }

  &.disabled {
    background-color: var(--color-primary-100);
    color: var(--color-primary-400);
    border: none;
  }

  > div {
    display: none;
  }
`

export const AdvancedOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const StyledCheckbox = styled(Checkbox)`
  letter-spacing: initial;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  button {
    flex: 1;
  }
`
